import { createUseStyles } from '@glu/theming';

export const styles = {
  controlBar: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: [20, 0, 30, 0],
  },
  controls: {
    alignItems: 'flex-start',
    display: 'flex',
  },
};

export default createUseStyles(styles);
